module.exports = __webpack_public_path__ + "sr.a96b947d.svg";